import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { URL_KKN_JOENSUU_FACEBOOK, URL_KKN_JOENSUU_INSTAGRAM } from "../url/index";
import LanguageSwitch from "./LanguageSwitch";
import logo from "../asset/logo_new.png";
class Navbar extends Component {
  render() {
    const { t } = this.props;
    return (
      <header style={{ position: "sticky", top: 0, zIndex: 1000, backgroundColor: "#052324" }}>
        <div class="container">
          <div class="header d-lg-flex justify-content-between align-items-center">
            <div class="header-agile">
              <h1>
                <Link to="/" class="navbar-brand logo" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                  <img 
                    src={logo} 
                    alt="Parturi KKN Logo" 
                    style={{ maxHeight: "70px", width: "auto", marginRight: "15px" }}
                  />
                  <div>
                    <span style={{fontSize: "32px", fontWeight: "bold", color: "#ffc905"}}>Parturi KKN Joensuu</span>
                    <p className="text-white" style={{fontSize: "11px", margin: "0", marginTop: "2px"}}>Torikatu 23, 80100 Joensuu</p>
                  </div>
                </Link>
              </h1>
            </div>
            <div style={{flexDirection:"row"}}>
            
            <ul className="list-inline social-buttons">
                    <li className="list-inline-item">
                      <a href={URL_KKN_JOENSUU_FACEBOOK} >
                      &nbsp; <i className="fa fa-facebook-official" style={{color: "#ffc905"}}></i>
                      </a>
                    </li>&nbsp;&nbsp;
                    <li className="list-inline-item">
                      <a href={URL_KKN_JOENSUU_INSTAGRAM} >
                        <i className="fa fa-instagram" style={{color: "#ffc905"}}></i>
                      </a>
                    </li>
                
                  </ul>
                  </div>
                 
            <div class="nav_w3ls">
              <nav>
                <label for="drop" class="toggle mt-lg-0 mt-1 row" style={{backgroundColor: "#ffc905"}}>
                  <p style={{fontSize:"14px", color:"black"}}>{t("nav.menu")}<span class="fa fa-bars" aria-hidden="true"></span></p>
                  
                </label>
                <input type="checkbox" id="drop" />
                <ul class="menu row">
                  <li class="mr-lg-3 mr-2 active">
                    <Link to="/">{t("nav.home")}</Link>
                  </li>
                  <li class="mr-lg-3 mr-2 active">
                    <Link to="/appointment">{t("nav.appointment")}</Link>
                  </li>
                  <li class="mr-lg-3 mr-2">
                    <Link to="/gallery">{t("nav.gallery")}</Link>
                  </li>
                  {/* <li class="mr-lg-3 mr-2">
                    <Link to="/about">{t("nav.about")}</Link>
                  </li> */}
                  <li class="mr-lg-3 mr-2">
                    <Link to="/contact">{t("nav.contact")}</Link>
                  </li>
                  <LanguageSwitch/>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default withTranslation("global")(Navbar);
